import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const CURRENCIES = [
  { value: 'TRY', label: 'TRY', symbol: '\u20BA' },
  { value: 'USD', label: 'USD', symbol: '$' },
];

export function CurrencySelect({ value, onValueChange, className, testId }) {
  return (
    <Select value={value || 'TRY'} onValueChange={onValueChange}>
      <SelectTrigger className={className} data-testid={testId || 'currency-select'}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {CURRENCIES.map(c => (
          <SelectItem key={c.value} value={c.value}>
            {c.symbol} {c.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export function getCurrencySymbol(currency) {
  if (currency === 'USD') return '$';
  return '\u20BA';
}

export { CURRENCIES };
